import { Link } from 'react-router-dom';

// Cartão discreto no Início: para quem não organiza, um convite para conhecer
// a área do organizador; para quem já tem evento, os atalhos da organização.
export default function CartaoOrganizador({ organiza }: { organiza: boolean }) {
  if (organiza) {
    return (
      <div className="rounded-[18px] bg-background-50 p-4 shadow-pcard">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[12px] bg-primary-50 text-primary-600">
            <i className="ri-calendar-check-line text-[20px]" aria-hidden />
          </span>
          <p className="min-w-0 flex-1 text-[15px] font-extrabold text-foreground-950">
            Área do organizador
          </p>
        </div>
        <div className="mt-3 flex gap-2">
          <Link
            to="/meus-eventos"
            className="aperta flex h-11 flex-1 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[14px] bg-primary-500 text-[14px] font-bold text-white transition-colors hover:bg-primary-600"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-layout-grid-line text-[18px]" aria-hidden />
            </span>
            Meus eventos
          </Link>
          <Link
            to="/criar"
            className="aperta flex h-11 flex-1 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[14px] border border-background-300 bg-background-50 text-[14px] font-bold text-foreground-800 transition-colors hover:bg-background-100"
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-add-line text-[18px]" aria-hidden />
            </span>
            Criar evento
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-[18px] bg-background-50 p-4 shadow-pcard">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[12px] bg-primary-50 text-primary-600">
          <i className="ri-calendar-2-line text-[20px]" aria-hidden />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-extrabold text-foreground-950">Organiza eventos?</p>
          <p className="mt-0.5 text-[13px] leading-snug text-foreground-600">
            Divulgue e venda ingressos, inscrições e fichas pelo celular.
          </p>
        </div>
      </div>
      <Link
        to="/conheca"
        className="aperta mt-3 flex h-11 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[14px] border border-primary-200 bg-primary-50 text-[14px] font-bold text-primary-700 transition-colors hover:bg-primary-100"
      >
        Saiba como
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-arrow-right-line text-[18px]" aria-hidden />
        </span>
      </Link>
    </div>
  );
}